module.exports = __webpack_public_path__ + "img/img_hospital.c671f674.png";